export default __webpack_public_path__ + "static/round-4d4bd17d983944fc14cc575efb2407f5.png";